var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_5030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37391 16.2713C8.0121 16.8571 9.02653 16.8487 9.65392 16.2525C10.2813 15.6563 10.2901 14.6923 9.67373 14.0858L5.55048 10.1673H21.3735C22.2718 10.1673 23 9.47525 23 8.62162C23 7.76798 22.2718 7.07597 21.3735 7.07597H5.55048L9.67373 3.15745C10.0965 2.76938 10.2661 2.1947 10.1173 1.6543C9.96841 1.11389 9.52431 0.691863 8.95566 0.550413C8.387 0.408962 7.78227 0.570104 7.37391 0.971905L0.476235 7.52684C-0.158745 8.13196 -0.158745 9.11127 0.476235 9.7164L7.37391 16.2713Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_5030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.a2825472d5edcff1aa438ebbb94d4f99.svg";
export { ForwardRef as ReactComponent };